import CheckmarkOutline16 from '@carbon/icons-react/es/checkmark--outline/16';
import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { ProjectId } from 'api/models';
import { Task } from 'data/tasks';
import { useTasksByIds } from 'data/tasks/hooks';

const SubtaskIcon = styled(CheckmarkOutline16)`
  margin: 0 var(--spacing-03);
`;

const IconText = styled.span`
  align-items: center;
  display: flex;
  margin-left: var(--spacing-02);
`;

export const TaskFooterAdditionalDetails: FC<{ task: Task }> = ({ task }) => {
  const subTasks = useTasksByIds(ProjectId(task.project), task.subTasks);
  const completedSubtasks = subTasks.filter((subtask) =>
    Boolean(subtask.completedAt),
  );
  const intl = useIntl();

  return (
    <>
      {Boolean(task.subTasks?.length) && (
        <Tooltip
          title={intl.formatMessage(
            {
              id: 'projects.plan.phase.task.subtask_completion',
            },
            {
              completed: completedSubtasks.length,
              total: task.subTasks.length,
            },
          )}
        >
          <IconText>
            <SubtaskIcon />
            {completedSubtasks.length}/{task.subTasks.length}
          </IconText>
        </Tooltip>
      )}
    </>
  );
};
